import { IRootState } from '../reducer.interface'

export const getLoanLeads = (state: IRootState) => {
  return state.loans.leads
}

export const getLoansPagination = (state: IRootState) => {
  return state.loans.pagination
}
